import React from 'react'
import CornerCSS from './corner.module.css'

const Corner = () => <div className={`${CornerCSS.angle} square`} />

export default Corner
